import { useContext, useEffect, useState } from 'react';
import {
	Button,
	Checkbox,
	Col,
	Form,
	Input,
	DatePicker,
	message,
	Radio,
	Row,
	Select,
	Tag,
} from 'antd';
import { IoIosArrowDown } from 'react-icons/io';

import { useQuery } from '../../../hooks/useQuery';
import Context from '../../../context/Context';
//import { api } from '../../../api/api';
import { isValidNric } from '../../../utils/utils';
import {
	getClinicalRolesApi,
	getClinicalDesignationApi,
	getUserInfoByIdApi,
	submitMakerUserCreationApi,
	checkExistingUsernameApi,
} from '../../../api/userOnboarding';
import { Modal } from 'antd';

import styles from './createUser.module.scss';
//import moment from 'moment';
import dayjs from 'dayjs';
const CreateUser = () => {
	const { appAccess, SSPFacilities, financeRoles } = useContext(Context);
	const { query } = useQuery();
	const userId = query.get('id');
	const userDetails = JSON.parse(localStorage.getItem('user-onboard-data'));
	const fullName = localStorage.getItem("fullName");
	const [form] = Form.useForm();

	const isAdmin = userDetails?.isAdmin === 'Y';

	const [formValues, setFormValues] = useState(null);
	const [submit, setSubmit] = useState({
		loading: false,
		success: null,
		error: null,
	});
	const [clinicalRoles, setClinicalRoles] = useState({
		loading: true,
		data: null,
		error: null,
	});
	const [clinicalDesignation, setClinicalDesignation] = useState({
		loading: true,
		data: null,
		error: null,
	});
	const [userData, setUserData] = useState({
		loading: false,
		data: null,
		error: null,
	});

	// Function to fetch data for clinical roles
// const getClinicalRoles = async () => {
// 	setClinicalRoles({ loading: true, data: null, error: null });
// 	try {
// 		const data = await getClinicalRolesApi(
// 			userDetails?.userId,
// 			form.getFieldValue('nhName')
// 		);

// 		setClinicalRoles({ loading: false, data, error: null });
// 	} catch (err) {
// 		setClinicalRoles({
// 			loading: false,
// 			data: null,
// 			error: err.message || 'Something went wrong',
// 		});
// 	}
// };

// // Function to fetch data for clinical designation
// const getClinicalDesignation = async () => {
// 	setClinicalDesignation({ loading: true, data: null, error: null });

// 	try {
// 		const data = await getClinicalDesignationApi(
// 			userDetails?.userId,
// 			form.getFieldValue('nhName')
// 		);

// 		setClinicalDesignation({
// 			loading: false,
// 			data: data,
// 			error: null,
// 		});
// 	} catch (err) {
// 		setClinicalDesignation({
// 			loading: false,
// 			data: null,
// 			error: err.message || 'Something went wrong',
// 		});
// 	}
// };



	// Function to fetch user details
	const getUserDetails = async () => {
		if (!userId) return;

		setUserData({ loading: true, data: null, error: null });

		try {
			

			// Set API response to state
			const response = await getUserInfoByIdApi(userId);
			setUserData({ loading: false, data: response, error: null });

			const formValues = {
				nhName: response.nhName || null,
				nhAdmin: [response.nhAdminRequired === true ? 'Required' : null],
				salutation: response.salutation || null,
				firstName: response.firstName || '',
				lastName: response.lastName || '',
				userName: response.userName || '',
				email: response.email || '',
				telephoneNumber: response.telephoneNumber || '',
				nric: response.nric || '',
				authType2FA: response.authType2FA || '',
				facilitycode:
					response.facilitycode?.split(',').map((item) => item.trim()) ||
					null,
				accessRequired: [
					response.hrAccessRequired === true ? 'HR' : null,
					response.financeAccessRequired === true ? 'Finance' : null,
					response.clinicalAccessRequired === true ? 'Clinical' : null,
				].filter(Boolean),
				hrFacilityCode: response.hrFacilityCode || null,
				financeFacilityCode: response.financeFacilityCode || null,
				financeRoles: response.financeRoles
					? response.financeRoles.split(',').map((id) => Number(id.trim()))
					: [],
				clinicalFacilityCode: response.clinicalFacilityCode
					? response.clinicalFacilityCode
							.split(',')
							.map((id) => Number(id.trim())) // Convert to array of numbers
					: [],

				classification: response.classification
					? Number(response.classification)
					: null,
				micrCode: response.micrCode || null,
				clinicalRoles: response.clinicalRoles
					? response.clinicalRoles
							.split(',')
							.map((id) => Number(id.trim()))
					: [],
				effectiveStartDate: response.effectiveStartDate
					? dayjs(response.effectiveStartDate)
					: null,
				completionEmailList:
					response.completionEmailList || userDetails?.email,
				remarks: response.remarks || '',
			};

			// Set form values immediately after fetching data
			form.setFieldsValue(formValues);
		} catch (err) {
			setUserData({
				loading: false,
				data: null,
				error: err.message || 'Something went wrong',
			});
		}
	};

	useEffect(() => {
		getUserDetails(); // eslint-disable-next-line
	}, [userId]);

	useEffect(() => {
	const nhNameValue = formValues?.nhName;

	if (!nhNameValue || !SSPFacilities?.data) return;

	const matchedFacilities = SSPFacilities.data.filter(
		(el) =>
			el.nhName?.trim().toLowerCase() === nhNameValue.trim().toLowerCase()
	);

	const hasValidClinicalCode = matchedFacilities.some(
		(item) =>
			item.clinicalFacilityCode !== null &&
			item.clinicalFacilityCode !== 'NA'
	);

	if (!hasValidClinicalCode) return;

	const fetchClinicalData = async () => {
		setClinicalRoles({ loading: true, data: null, error: null });
		setClinicalDesignation({ loading: true, data: null, error: null });

		try {
			const [rolesData, designationData] = await Promise.all([
				getClinicalRolesApi(userDetails?.userId, nhNameValue),
				getClinicalDesignationApi(userDetails?.userId, nhNameValue),
			]);

			setClinicalRoles({
				loading: false,
				data: rolesData,
				error: null,
			});

			setClinicalDesignation({
				loading: false,
				data: designationData,
				error: null,
			});
		} catch (err) {
			setClinicalRoles({
				loading: false,
				data: null,
				error: err.message || 'Something went wrong',
			});

			setClinicalDesignation({
				loading: false,
				data: null,
				error: err.message || 'Something went wrong',
			});
		}
	};

	fetchClinicalData();
}, [formValues?.nhName, SSPFacilities?.data, userDetails?.userId]);

	const nhNameData = userDetails?.nhName
	? userDetails.nhName.split(',').map((item) => item.trim()).filter(Boolean)
	: [];
	const hasMultipleNH = nhNameData.length > 1;
	// SSP Facility Code
	const sspFacilityCode = SSPFacilities.data?.filter(
		(el) =>
			el.nhName?.trim().toLowerCase() ===
			form.getFieldValue('nhName')?.trim()?.toLowerCase()
	);

	// Clinical Facility Code
	const clinicalFacilityCode = SSPFacilities.data
		?.filter(
			(el) =>
				el.nhName?.trim().toLowerCase() ===
				form.getFieldValue('nhName')?.trim()?.toLowerCase()
		)
		.map((el) => ({
			label: el.facilityName,
			value: Number(el.clinicalFacilityCode),
		}));

	const onFinish = async (values) => {
	setSubmit({ loading: true, success: null, error: null });

	const nhAdminFacilities = isAdmin
		? 'ALL Facilities'
		: userDetails?.facilityCode
				?.split(',')
				.map((code) => code.trim())
				.filter((code) => code !== 'UAM')
				.join(',');

	const formdataObject = {
		...values,
		nhAdminFacilities,
		effectiveStartDate: values.effectiveStartDate
			? values.effectiveStartDate.format('YYYY-MM-DDTHH:mm:ss')
			: null,
		nhName: values.nhName?.trim(),
		salutation: values.salutation,
		firstName: values.firstName?.trim(),
		lastName: values.lastName?.trim(),
		nhAdminRequired: values.nhAdmin?.includes('Required') ? 1 : 0,
		nric: values.nric,
		telephoneNumber: values.telephoneNumber || null,
		userName: values.userName || null,
		facilitycode: values.facilitycode?.join(',')?.trim(),
		hrAccessRequired:
			values.accessRequired && values.accessRequired.includes('HR') ? 1 : 0,
		financeAccessRequired:
			values.accessRequired && values.accessRequired.includes('Finance') ? 1 : 0,
		clinicalAccessRequired:
			values.accessRequired && values.accessRequired.includes('Clinical') ? 1 : 0,
		financeFacilityCode: values.financeFacilityCode,
		hrFacilityCode: values.hrFacilityCode,
		financeRoles:
			values.financeRoles?.length > 0 ? values.financeRoles.join(',') : '',
		financeRolesDesc:
			values.financeRoles?.length > 0
				? values.financeRoles
						.map((roleId) => {
							const matchingRole = financeRoles.data.find(
								(role) => role.roleId === roleId
							);
							return matchingRole ? matchingRole.name : null;
						})
						.filter(Boolean)
						.join(',')
				: '',
		classification: values.classification,
		classificationDesc:
			clinicalDesignation.data?.find(
				(item) => item.userClassificationId === values.classification
			)?.classificationName || '',
		clinicalRoles:
			values.clinicalRoles?.length > 0 ? values.clinicalRoles.join(',') : '',
		clinicalRolesDesc:
			values.clinicalRoles?.length > 0
				? values.clinicalRoles
						.map((roleId) => {
							const matchingRole = clinicalRoles.data.find(
								(role) => role.id === roleId
							);
							return matchingRole ? matchingRole.userRole : null;
						})
						.filter(Boolean)
						.join(',')
				: '',
		clinicalFacilityCode:
			values.clinicalFacilityCode?.length > 0
				? values.clinicalFacilityCode.join(',')
				: '',
		clinicalFacilityCodeDesc:
			values.clinicalFacilityCode?.length > 0
				? values.clinicalFacilityCode
						.map((code) => {
							const facility = clinicalFacilityCode.find(
								(item) => item.value === code
							);
							return facility ? facility.label : null;
						})
						.filter(Boolean)
						.join(',')
				: '',
		createdBy: userDetails?.userId,
		status: 'P',
	};

	Object.keys(formdataObject).forEach((key) => {
		if (Array.isArray(formdataObject[key])) {
			formdataObject[key] = formdataObject[key].join(', ');
		}
	});

	if (userId && userData?.data?.id) {
		formdataObject.id = userData.data.id;
		formdataObject.modifiedBy = userDetails?.userId;
	}

	delete formdataObject.accessRequired;

	try {
		await submitMakerUserCreationApi(formdataObject);

		setSubmit({
			loading: false,
			success: 'User creation request submitted successfully!',
			error: null,
		});

		message.success(
			`User ${userId ? 'update' : 'create'} request submitted successfully!`
		);

		form.resetFields();
	} catch (err) {
		console.error('Error:', err.message || 'Something went wrong');

		setSubmit({
			loading: false,
			success: null,
			error:
				err.message ||
				`Failed to ${
					userId ? 'update' : 'create'
				} user request please drop email to Admin!`,
		});

		message.error(
			`Failed to ${
				userId ? 'update' : 'create'
			} user request please drop email to Admin!`
		);

		form.resetFields();
	}
};

	const salutationOptions = [
		{
			value: '0',
			label: 'Mr',
		},
		{
			value: '1',
			label: 'Ms',
		},
		{
			value: '2',
			label: 'Dr (Mr)',
		},
		{
			value: '3',
			label: 'Dr (Ms)',
		},
	];

	const isNricMandatory = (selectedAppAccess) => {
		form.validateFields(['nric']);
		return appAccess.data?.some(
			(option) =>
				selectedAppAccess.includes(option.nhName) &&
				option.nricMandatory === true
		);
	};

	const isMobileMandatory = (selectedAppAccess) => {
		form.validateFields(['telephoneNumber']);
		return appAccess.data?.some(
			(option) =>
				selectedAppAccess.includes(option.nhName) &&
				option.mobileNoMandatory === true
		);
	};

	const tagRender = (props) => {
		const { label, closable, onClose } = props;
		const onPreventMouseDown = (event) => {
			event.preventDefault();
			event.stopPropagation();
		};

		return (
			<Tag
				color={'#ff6a95'}
				onMouseDown={onPreventMouseDown}
				closable={closable}
				onClose={onClose}
				style={{
					marginInlineEnd: 4,
				}}
			>
				{label}
			</Tag>
		);
	};

	const initialValues = userId
		? {}
		: {
				authType2FA: 'gauth',
				completionEmailList: userDetails?.email,
				nhName: isAdmin ? null : (hasMultipleNH ? null : nhNameData[0] || null),
				effectiveStartDate: dayjs(),
		  };

	return (
		<div className={styles['container']}>
			<div className={styles['wrapper']}>
				<div className={styles['intro-para']}>
					<div className={styles['header-block']}>
						<h1 className={styles['page-title']}>
						User <span>Onboarding</span>
						</h1>

						<p className={styles['subtitle']}>
						Securely onboard users into the system
						</p>
					</div>
		
					<p className={styles['head-text']}>
						Dear {fullName ?? userDetails?.userId},
					</p>

					<p className={styles['head-text']}>
						Please {userId ? 'update' : 'fill'} the below form to onboard a new user.
					</p>
				</div>



				<Form
					id="user-onboarding-form"
					name="user-onboarding-form"
					form={form}
					labelCol={{ span: 24 }}
					disabled={
						submit.loading ||
						appAccess.error?.length > 0 ||
						clinicalRoles.error?.length > 0 ||
						clinicalDesignation.error?.length > 0 ||
						SSPFacilities.error?.length > 0 ||
						financeRoles.error?.length > 0 ||
						userData.loading
					}
					onFinish={onFinish}
					validateTrigger={['onBlur', 'onChange']}
					onValuesChange={(changedValues, allValues) => {
					setFormValues(allValues);

					const fieldsToValidate = ['micrCode', 'HRFacilityCode', 'FinanceFacilitycode', 'nric'];

					if (form.isFieldTouched('telephoneNumber')) {
						fieldsToValidate.push('telephoneNumber');
					}

					form.validateFields(fieldsToValidate);
					}}
					initialValues={initialValues}
				>
					<Row gutter={20}>
						{/* Nursing Home Name */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="Nursing Home Name"
								name="nhName"
								rules={[
									{
										required: true,
										message: 'Please select Nursing Home Name!',
									},
								]}
							>
								{isAdmin || hasMultipleNH ? (
									<Select
										placeholder="Please select Nursing Home Name"
										suffixIcon={<IoIosArrowDown style={{ fontSize: '14px' }} />}
										options={nhNameData.map((item) => ({
											label: item,
											value: item,
										}))}
										onChange={() => {
											form.validateFields(['telephoneNumber']);
											form.setFieldsValue({
												facilitycode: null,
												hrFacilityCode: null,
												financeFacilityCode: null,
												financeRoles: null,
												clinicalFacilityCode: null,
												classification: null,
												micrCode: null,
												clinicalRoles: null,
											});
										}}
									/>
								) : (
									<Input placeholder="Nursing Home Name" disabled />
								)}
							</Form.Item>
						</Col>
						{/* Salutation */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="Salutation"
								name="salutation"
								rules={[
									{
										required: true,
										message: 'Please select salutation!',
									},
								]}
							>
								<Select
									placeholder="Please select salutation"
									suffixIcon={<IoIosArrowDown style={{ fontSize: '14px' }} />}
									options={salutationOptions}
								/>
							</Form.Item>
						</Col>
						{/* First Name */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="First Name"
								name="firstName"
								tooltip={"User’s first name as per official records"}
								rules={[
									{
										required: true,
										message: 'Please input first name!',
									},
									{
										validator: (_, value) => {
											// let required rule handle empty
											if (!value || !value.trim()) {
												return Promise.resolve();
											}

											const trimmed = value.trim();

											// allow letters + numbers and max one space
											const validNameRegex = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)?$/;

											if (!validNameRegex.test(trimmed)) {
												return Promise.reject(
													new Error(
														'can contain letters only and may include at most one space between 2 names'
													)
												);
											}

											return Promise.resolve();
										},
									},
								]}
							>
								<Input placeholder="Please input first name!" />
							</Form.Item>
						</Col>
						{/* Last Name */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="Last Name"
								name="lastName"
								tooltip={
									"Used to generate the User ID. The system takes the first 5 characters of the last name. If the last name has two words, the second word will be used (e.g., Tan Smith → smith)"
								}
								rules={[
									{
										required: true,
										message: 'Please input last name!',
									},
									{
										validator: (_, value) => {
											// let "required" handle empty value
											if (!value || !value.trim()) {
												return Promise.resolve();
											}

											const trimmed = value.trim();

											// letters + numbers, optional one single space between 2 parts
											const validNameRegex = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)?$/;

											if (!validNameRegex.test(trimmed)) {
												return Promise.reject(
													new Error(
														'Last Name can contain letters only and may include at most one space between 2 names. If the user does not have a last name, repeat the First Name in this field.'
													)
												);
											}

											return Promise.resolve();
										},
									},
								]}
							>
								<Input placeholder="Please input last name!" />
							</Form.Item>
						</Col>
						{/* SSO Facility Code */}
						{<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="SSO Facility Code"
								name="facilitycode"
								tooltip={
									!form.getFieldValue('nhName')
										? 'Please select Nursing Home Name'
										: 'For multi-facility organizations, select the SSO facility code corresponding to the facility the user should access. You can select multiple.'
								}
								rules={[
									{
										required: true,
										message: 'Please select SSO Facility Code!',
									},
								]}
							>
								<Select
									mode="multiple"
									tagRender={tagRender}
									allowClear
									placeholder="Please select SSO Facility Code"
									suffixIcon={<IoIosArrowDown style={{ fontSize: '14px' }} />}
									options={sspFacilityCode?.map((item) => ({
										label: item?.facilityName,
										value: item?.facility,
									}))}
									disabled={!form.getFieldValue('nhName')}
								/>
							</Form.Item>
						</Col>}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="NH Admin Access Required"
								name="nhAdmin"
								tooltip={"Select this if the user required NH Admin Access"}
								rules={[
									{
										required: false,
									},
								]}
							>
								<Checkbox.Group
									disabled={!form.getFieldValue('nhName')}
									options={[
										{
											value: 'Required',
											label: 'Required',

										},
									]}
								/>
							</Form.Item>
						</Col>

						{/* Existing NHELP/ILTC/IRMS Username */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="Existing ECCareSuite/NHELP/ILTC/IRMS Username"
								name="userName"
								validateTrigger="onBlur"
								rules={[
									{
										validator: async (_, value) => {
											if (!value || !value.trim()) {
												return Promise.resolve();
											}

											const username = value.trim();
											const lower = username.toLowerCase();
											const nhName = form.getFieldValue('nhName')?.trim();

											if (['na', 'n/a', 'nil'].includes(lower)) {
												return Promise.reject(
													new Error('Leave blank if no existing user id')
												);
											}

											if (nhName?.toUpperCase() === 'HNF') {
												return Promise.resolve();
											}

											try {
												const result = await checkExistingUsernameApi(username);

												// Adjust this based on your actual API response
												const exists =
													result === true ||
													result?.exists === true ||
													result?.data === true ||
													result?.valid === true;

												if (!exists) {
													form.setFieldsValue({ userName: null });

													Modal.error({
														title: 'Username Not Found',
														content: 'Entered username does not exist. Leave Blank for new username creation',
														okText: 'Close'
													});

													return Promise.reject(new Error('Entered username does not exist. Leave Blank for new username creation'));
												}

												return Promise.resolve();
											} catch (err) {
												return Promise.reject(
													new Error(err?.message || 'Unable to validate username')
												);
											}
										},
									},
								]}
							>
								<Input placeholder="Please input Existing NHELP/ILTC/IRMS Username!" />
							</Form.Item>
						</Col>
						{/* Email Address */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="Email Address"
								name="email"
								tooltip="May be a personal or official email address. Used as an alternative authentication method if the authenticator app is unavailable assigned by TSS Admin."
								rules={[
									{
										type: 'email',
										whitespace: true,
										message: 'Please enter valid email!',
									},
								]}
							>
								<Input
									type="email"
									placeholder="Please input Email Address!"
									onChange={(e) => {
										const email = e.target.value;
										const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

										if (!emailRegex.test(email)) {
											form.setFieldsValue({ appendEmail: false });
										}
									}}
								/>
							</Form.Item>

							{/* Checkbox */}
							<Form.Item shouldUpdate={(prev, cur) => prev.email !== cur.email || prev.completionEmailList !== cur.completionEmailList} noStyle>
								{({ getFieldValue, setFieldsValue }) => {
									const email = (getFieldValue('email') || '').trim();
									const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

									return (
										<Form.Item
											name="appendEmail"
											valuePropName="checked"
											
										>
											<Checkbox
												disabled={!valid}
												onChange={(e) => {
													const checked = e.target.checked;

													const existing = getFieldValue('completionEmailList') || '';
													const emails = existing
														.split(',')
														.map((x) => x.trim())
														.filter(Boolean);

													if (checked) {
														// ADD
														if (!emails.includes(email)) {
															setFieldsValue({
																completionEmailList: [...emails, email].join(', '),
															});
														}
													} else {
														// REMOVE
														const updated = emails.filter((x) => x.toLowerCase() !== email.toLowerCase());
														setFieldsValue({
															completionEmailList: updated.join(', '),
														});
													}
												}}
											>
												Add to Confirmation Email List
											</Checkbox>
										</Form.Item>
									);
								}}
							</Form.Item>
						</Col>
						{/* Mobile Number */}
						<Col xs={24} md={12} xl={8}>
							<Form.Item
								label="Mobile Number"
								name="telephoneNumber"
								// Strips non-digits FIRST, then enforces maximum 8 characters
								getValueFromEvent={(e) => {
									const digitsOnly = e.target.value.replace(/\D/g, '');
									return digitsOnly.slice(0, 8);
								}}
								normalize={(value) => (value ? value.replace(/\D/g, '').slice(0, 8) : '')}
								rules={[
									{
										required: formValues?.appAccess
											? isMobileMandatory(formValues.appAccess)
											: false,
										message: 'Please input Mobile Number!',
									},
									{
										pattern: /^\d{8}$/,
										message: 'Mobile Number must be exactly 8 digits!',
									},
								]}
							>
								<Input
									type="text"
									inputMode="numeric"
									placeholder="Please input Mobile Number!"
									// DO NOT put maxLength={8} here so spaces are cleaned before truncation
								/>
							</Form.Item>
						</Col>
						{/* NRIC / FIN */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="NRIC / FIN"
								name="nric"
								tooltip={"Used in the User ID and default password generation (e.g., G8765432C → smith432c)"}
								rules={[
									{
										required: formValues?.nhName
											? isNricMandatory(formValues.nhName)
											: false,
										message: 'Please input NRIC / FIN!',
									},
									{
										validator: (_, value) => {
											if (!value || isValidNric(value)) {
												return Promise.resolve();
											}
											return Promise.reject(new Error('Invalid NRIC / FIN!'));
										},
									},
								]}
							>
								<Input placeholder="Please input NRIC / FIN!" />
							</Form.Item>
						</Col>
						{/* 2FA Auth Type */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item label="2FA Auth Type" name="authType2FA" tooltip={"Two-factor authentication method. Default is Authenticator"}>
								<Radio.Group disabled={!isAdmin}>
									<Radio value={'gauth'}>Google/Microsoft Auth</Radio>
									<Radio value={'singpass'}>SingPass</Radio>
								</Radio.Group>
							</Form.Item>
						</Col>
						
						{/* Access Required */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="Access Required"
								name="accessRequired"

								tooltip={
									!form.getFieldValue('nhName')
										? 'Please select Nursing Home Name'
										: 'Select the system modules the user needs access to. You may choose one or more options.'
								}
								rules={[
									{
										required: sspFacilityCode?.some(
											(item) =>
												item?.hrFacilityCode !== null ||
												item?.financeFacilityCode !== null ||
												item?.clinicalFacilityCode !== null
										),
										message: 'Please select at least one access!',
									},
								]}
							>
								<Checkbox.Group
									disabled={!form.getFieldValue('nhName')}
									options={[
										{
											value: 'HR',
											label: 'HR',
											disabled: !sspFacilityCode?.some(
												(item) => item?.hrFacilityCode !== null
											),
										},
										{
											value: 'Finance',
											label: 'Finance',
											disabled: !sspFacilityCode?.some(
												(item) => item?.financeFacilityCode !== null
											),
										},
										{
											value: 'Clinical',
											label: 'Clinical',
											disabled: !sspFacilityCode?.some(
												(item) => item?.clinicalFacilityCode !== null
											),
										},
									]}
								/>
							</Form.Item>
						</Col>
						{/* HR FacilityCode */}
						{form.getFieldValue('accessRequired')?.includes('HR') && (
							<Col xs={24} md={12} xxl={8}>
								<Form.Item
									label="HR FacilityCode"
									name="hrFacilityCode"
									rules={[
										{
											required:
												formValues?.accessRequired?.includes('HR') &&
												sspFacilityCode?.filter(
													(item) => item?.hrFacilityCode !== null
												)?.length > 0
													? true
													: false,
											message: 'Please select HR FacilityCode!',
										},
									]}
								>
									<Select
										allowClear
										placeholder="Please select HR FacilityCode"
										suffixIcon={<IoIosArrowDown style={{ fontSize: '14px' }} />}
										disabled={
											!sspFacilityCode?.some(
												(item) => item?.hrFacilityCode !== null
											)
										}
										options={sspFacilityCode
											?.filter((item) => item?.hrFacilityCode !== null)
											.map((item) => ({
												label: item?.hrFacilityCode,
												value: item?.hrFacilityCode,
											}))}
									></Select>
								</Form.Item>
							</Col>
						)}
						{/* Finance */}
						{form.getFieldValue('accessRequired')?.includes('Finance') && (
							<>
								{/* Finance Facility code */}
								<Col xs={24} md={12} xxl={8}>
									<Form.Item
										label="Finance Facility code"
										name="financeFacilityCode"
										tooltip={"Select the Finance Facility code required access to the user"}
										rules={[
											{
												required:
													formValues?.accessRequired?.includes('Finance') &&
													sspFacilityCode?.filter(
														(item) => item?.financeFacilityCode !== null
													)?.length > 0
														? true
														: false,
												message: 'Please select Finance Facility code!',
											},
										]}
									>
										<Select
											allowClear
											optionFilterProp={'label'}
											// labelInValue={true}
											showSearch
											placeholder="Please select Finance Facility code"
											suffixIcon={
												<IoIosArrowDown style={{ fontSize: '14px' }} />
											}
											disabled={
												!sspFacilityCode?.some(
													(item) => item?.financeFacilityCode !== null
												)
											}
											options={[
												...new Map(
													sspFacilityCode
														?.filter(
															(item) => item?.financeFacilityCode !== null
														)
														.map((item) => [
															item.financeFacilityCode,
															{
																label: item.financeFacilityCode,
																value: item.financeFacilityCode,
															},
														])
												).values(),
											]}
										/>
									</Form.Item>
								</Col>

								{/* Finance Roles  */}
								<Col xs={24} md={12} xxl={8}>
									<Form.Item
										label="Finance Roles"
										name="financeRoles"
										tooltip={"Select the Finace Roles required for the user. You can select multiple"}
										rules={[
											{
												required: form
													.getFieldValue('accessRequired')
													?.includes('Finance')
													? true
													: false,
												message: 'Please select Finance Roles!',
											},
										]}
									>
										<Select
											mode="multiple"
											tagRender={tagRender}
											allowClear
											optionFilterProp={'label'}
											// labelInValue={true}
											showSearch
											placeholder="Please select Finance Roles"
											suffixIcon={
												<IoIosArrowDown style={{ fontSize: '14px' }} />
											}
											options={financeRoles?.data?.map((item) => ({
												label: item?.name,
												value: item?.roleId,
											}))}
										/>
									</Form.Item>
								</Col>
							</>
						)}
						{/* Clinical */}
						{form.getFieldValue('accessRequired')?.includes('Clinical') && (
							<>
								{/* Clinical Facility Code */}
								<Col xs={24} md={12} xxl={8}>
									<Form.Item
										label="Clinical Facility"
										name="clinicalFacilityCode"
										tooltip={"Select the access required in Clinical Facility. You can select multiple"}
										rules={[
											{
												required:
													form
														.getFieldValue('accessRequired')
														?.includes('Clinical') &&
													sspFacilityCode?.filter(
														(item) => item?.clinicalFacilityCode !== null
													)?.length > 0
														? true
														: false,
												message: 'Please select Clinical Facility!',
											},
										]}
									>
										<Select
											mode="multiple"
											tagRender={tagRender}
											allowClear
											placeholder="Please select Clinical Facility"
											optionFilterProp={'label'}
											suffixIcon={
												<IoIosArrowDown style={{ fontSize: '14px' }} />
											}
											disabled={
												!sspFacilityCode?.some(
													(item) => item?.clinicalFacilityCode !== null
												)
											}
											options={clinicalFacilityCode}
										/>
									</Form.Item>
								</Col>
								{/* Clinical Designation */}
								<Col xs={24} md={12} xxl={8}>
									<Form.Item
										label="Clinical Designation"
										name="classification"
										tooltip={"Select Clinical Designation required for the user"}
										rules={[
											{
												required: form
													.getFieldValue('accessRequired')
													?.includes('Clinical')
													? true
													: false,
												message: 'Please select Clinical Designation!',
											},
										]}
									>
										<Select
											placeholder="Please select Clinical Designation"
											optionFilterProp={'label'}
											// labelInValue={true}
											showSearch
											suffixIcon={
												<IoIosArrowDown style={{ fontSize: '14px' }} />
											}
											options={clinicalDesignation.data?.map((item) => ({
												label: item?.classificationName,
												value: item?.userClassificationId,
											}))}
										/>
									</Form.Item>
								</Col>
								{/* MICR Code */}
								<Col xs={24} md={12} xxl={8}>
									<Form.Item
										label="MICR Code"
										name="micrCode"
										tooltip={"Mandatory if the user is a Doctor/GP"}
										rules={[
											{
												required:
													form.getFieldValue('salutation') === '2' ||
													form.getFieldValue('salutation') === '3',
												message: 'Please input MICR Code!',
											},
										]}
									>
										<Input placeholder="Please input MICR Code!" />
									</Form.Item>
								</Col>
								{/* Clinical Roles */}
								<Col xs={24} md={12} xxl={8}>
									<Form.Item
										label="Clinical Roles"
										name="clinicalRoles"
										tooltip={"If multiple locations are selected, the chosen roles will be applied to all selected locations"}
										rules={[
											{
												required: form
													.getFieldValue('accessRequired')
													?.includes('Clinical')
													? true
													: false,
												message: 'Please select Clinical Roles!',
											},
										]}
									>
										<Select
											mode="multiple"
											tagRender={tagRender}
											allowClear
											optionFilterProp={'label'}
											// labelInValue={true}
											placeholder="Please select Clinical Roles"
											suffixIcon={
												<IoIosArrowDown style={{ fontSize: '14px' }} />
											}
											options={clinicalRoles?.data?.map((item) => ({
												label: item?.userRole,
												value: item?.id,
											}))}
										/>
									</Form.Item>
								</Col>
							</>
						)}
						{/* Effective Start Date */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="Effective Start Date"
								name="effectiveStartDate"
								tooltip={"Select the date when the user account should be created; default is set to today. The confirmation email will be sent on this date"}
								rules={[
									{
										required: true,
										message: 'Please select Effective Start Date.',
									},
								]}
							>
								<DatePicker
									style={{ width: '100%' }}
									format="YYYY-MM-DD"
									disabledDate={(current) => current && current.isBefore(dayjs().startOf('day'))}
									placeholder="Select Effective Start Date"
								/>
							</Form.Item>
						</Col>
						{/* Completion Email List */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item
								label="Confirmation Email List"
								name="completionEmailList"
								tooltip="Enter the email addresses that should receive the confirmation notification. Separate multiple emails with commas(,)"
								rules={[
									{
										required: true,
										message: 'At least one email is required.',
									},
									{
										validator: (_, value) => {
											if (!value) {
												return Promise.resolve();
											}

											// Split the string by commas and trim spaces
											const emails = value
												.split(',')
												.map((email) => email.trim());

											// Check if every email is valid
											const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
											const invalidEmails = emails.filter(
												(email) => !emailRegex.test(email)
											);

											if (invalidEmails.length > 0) {
												return Promise.reject(
													`Invalid emails: ${invalidEmails.join(', ')}`
												);
											}

											// Check for duplicate emails
											const emailCounts = emails.reduce((acc, email) => {
												acc[email] = (acc[email] || 0) + 1;
												return acc;
											}, {});
											const duplicateEmails = Object.keys(emailCounts).filter(
												(email) => emailCounts[email] > 1
											);

											if (duplicateEmails.length > 0) {
												return Promise.reject(
													`Duplicate emails: ${duplicateEmails.join(', ')}`
												);
											}

											return Promise.resolve();
										},
									},
								]}
							>
								<Input.TextArea
									autoSize={{
										minRows: 3,
										maxRows: 5,
									}}
									placeholder="Please input Confirmation Email List"
								/>
							</Form.Item>
						</Col>
						{/* Remarks */}
						<Col xs={24} md={12} xxl={8}>
							<Form.Item label="Remarks" name="remarks" tooltip={"Enter any special instructions, such as restricting access to a specific ward or level, or requesting additional permissions"}>
								<Input.TextArea
									placeholder="Please input Remarks!"
									autoSize={{
										minRows: 3,
										maxRows: 5,
									}}
								/>
							</Form.Item>
						</Col>

						<Col xs={24}>
							<Form.Item style={{ marginBottom: 0 }}>
								<Button
									className="premium-btn"
									loading={submit.loading}
									type="primary"
									htmlType="submit"
									block
								>
									{userId ? 'Update' : 'Request'} User
								</Button>

							</Form.Item>
						</Col>
					</Row>
				</Form>
			</div>
		</div>
	);
};

export default CreateUser;
